const translationKeys = {
  forms_boolean_true: 'forms_boolean_true',
  forms_boolean_false: 'forms_boolean_false',
  forms_phone_country_code: 'forms_phone_country_code',
  forms_step_previous: 'forms_step_previous',
  forms_step_next: 'forms_step_next',
};

Object.freeze(translationKeys);

export default translationKeys;
